export const API = {
  PROFILE: {
    DEFAULT: 'users/profile',
    EDIT: 'parents/profile',
    UPLOAD_FILE: 'parents/upload',
    CHANGE_PASSWORD: 'users/change-password',
    NOTIFY_SETTING: (parentId: string) => `users/${parentId}/setting`,
  },
  AUTH: {
    LOGIN: 'auth/login',
    REGISTER: 'auth/register',
    RESEND_OTP: 'auth/resend-code',
    VERIFY_PHONE: 'auth/verify-account',
    FORGOT_PASSWORD: 'auth/forgot-password',
    CHECK_CODE: 'auth/check-code',
    RESET_PASSWORD: 'auth/reset-password',
    CHOOSE_ROLE: 'auth/choose-role',
    REFRESH_TOKEN: 'auth/refresh-token',
  },
  PAYMENT: {
    GET_CREDIT_BALANCE: 'subscriptions/my-subscription',
    GET_ALL_CARDS: '/payment/payment-methods',
    CREATE_PAYMENT_METHOD: '',
    PAY_SEARCH_FEE: 'payment/pay-search-fee',
    ATTACH_PAYMENT_METHOD: 'payment/payment-methods/attach',
    BUY_PACKAGE: 'payment/purchase-package',
    TRIAL_JOB: 'payment/pay-trial-job',
    NORMAL_JOB: 'ac-jobs/pay-ac',
    EXTEND_JOB: 'ac-jobs/pay-extend-ac',
    PAY_JOB_BY_TOP_UP: 'payment/pay-ac-job-by-top-up',
    PAY_EXTEND_JOB_TOP_UP: 'payment/pay-extend-ac-job-by-top-up',
    PAY_EXTEND_TRIAL_JOB: 'payment/pay-extension-trial-job',
    CHECKOUT: {
      CHECKOUT_TRIAL_JOB: 'payment/checkout/pay-trial-job',
      CHECKOUT_SEARCH_FEE: 'payment/checkout/pay-search-fee',
      CHECKOUT_AC_JOB: 'ac-jobs/checkout/pay-ac',
      CHECKOUT_PAY_PACKAGE: 'payment/checkout/purchase-package',
      CHECKOUT_EXTEND: 'ac-jobs/checkout/pay-extend-ac',
    },
    GET_CONFIG_ADMIN: 'payment/configs/gateway-fee',
    PAYMENT_CREDIT_WITH_ZERO_AMOUNT: 'payment/pay-extend-ac-job-by-credit',
  },
  CREDITS: {
    GET_BALANCE: (id: string) => `subscription-purchases/balance/${id}`,
    GET_PACKAGES: 'packages/can-purchases',
    SUBSCRIPTION_PURCHASE: 'subscription-purchases',
    TRANSACTION_HISTORY_BY_CREDIT: 'wallet-transactions',
    TRANSACTION_HISTORY_BY_CASH: 'payment/ac/cash-transactions',
  },
  STATIC_DATA: {
    NATIONALITY: 'staticdata/nationality',
    ETHNICITY: 'staticdata/ethnicity',
  },
  OVERVIEW: {
    GET_OVERVIEW: 'ac-base-requests/my-request',
    UPDATE_STATUS_SITTER: (id: string) => `ac-base-request-sitters/${id}`,
  },
  SITTER: {
    DETAIL: 'srequests/sitters',
    REVIEWS: 'reviews',
    REPORT: 'report',
    REPORT_REASON: 'report/reasons',
  },
  JOB: {
    LIST: 'ac-jobs',
    UPDATE: (id: string) => `ac-jobs/extend/${id}`,
    DETAIL: (id: string) => `ac-jobs/${id}`,
    CANCEL: (id: string) => `/ac-jobs/cancel-ac/${id}`,
    PREVIEW_EXTEND: (id: string) => `ac-jobs/extend/preview/${id}`,
    UNDO_EXTEND: (id: string) => `ac-jobs/${id}/unpaid-extension`,
    MARK_COMPLETED: (id: string) => `ac-jobs/mark-as-completed/${id}`,
  },
  PARENT: {
    GET_CHILDREN: 'parents/children',
    ADD_CHILDREN: 'parents/children',
    UPDATE_CHILDREN: (id: string) => `parents/children/${id}`,
    DELETE_CHILDREN: (id: string) => `parents/children/${id}`,
    GET_ADDRESS: 'parents/address',
    ADD_ADDRESS: 'parents/address',
    UPDATE_ADDRESS: (id: string) => `parents/address/${id}`,
    DELETE_ADDRESS: (id: string) => `parents/address/${id}`,
    GET_REGION_LIST: 'regions',
    GET_ADD_BY_CODE: (postalCode: number) => `onemap/address/${postalCode}`,
    JOIN_SUBS: 'subscriptions',
  },
  NOTIFICATIONS: {
    CREATE_DEVICE_TOKEN: 'notifications/device-token',
    DELETE_DEVICE_TOKEN: 'notifications/device-token',
    GET_LIST: 'notifications',
    MARK_AS_READ: (id: string) => `notifications/mark-as-read/${id}`,
    MARK_ALL_AS_READ: 'notifications/mark-all-as-read',
  },
  UPLOAD: {
    GET_PRESIGNED_URL: '',
    UPLOAD_FILE: 'parents/upload',
    UPLOAD_URL: 'payment/upload-by-url',
  },
  SERVICE_AGREEMENTS: {
    CREATE: 'service-agreements',
  },
};
